module.exports = __webpack_public_path__ + "43f5118463d1f1b430bf216caf478b22.jpg";